import fetchData from './fetchData';
import './header';
import './footer';
import Accordion from './accordion';
import '../scss/index.scss';

document.addEventListener('DOMContentLoaded', () => {
  fetchData();
  Accordion();
})
